/**
 * PM Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BrandedStringArray } from './brandedStringArray';
import { WooDescription } from './wooDescription';
import { RealVariation } from './realVariation';
import { AdditionalVariation } from './additionalVariation';
import { BrandedQuantityDiscounts } from './brandedQuantityDiscounts';
import { WooProductImage } from './wooProductImage';
import { BrandedNumber } from './brandedNumber';
import { Variation } from './variation';
import { ProductAngle } from './productAngle';


export interface ProductTranslation { 
    _id: object;
    state: ProductTranslation.StateEnum;
    productType: ProductTranslation.ProductTypeEnum;
    name: string;
    customEntityName: string;
    type: ProductTranslation.TypeEnum;
    status: ProductTranslation.StatusEnum;
    catalog_visibility: ProductTranslation.CatalogVisibilityEnum;
    descriptions: Array<WooDescription>;
    placement: string;
    categories: Array<BrandedStringArray>;
    short_description: string;
    featuredImage: WooProductImage | null;
    featuredVideo: WooProductImage | null;
    wistia_video_id: string;
    sku: string;
    regular_price: Array<BrandedNumber>;
    sale_price: Array<BrandedNumber>;
    retail_price: Array<BrandedNumber>;
    minimum_price: Array<BrandedNumber>;
    relation_tags: Array<BrandedStringArray>;
    default_attributes: Array<object>;
    attributes: Array<object>;
    meta_data: Array<object>;
    imageGallery: Array<WooProductImage>;
    version: number;
    quantityDiscounts: Array<BrandedQuantityDiscounts>;
    additional_variations_data: Array<AdditionalVariation>;
    fake_variation_price_offset: number;
    real_variation: RealVariation;
    stock_status: string;
    extended_warranty: boolean;
    google_product_category: string;
    marketing_product_type: string;
    tax_class: ProductTranslation.TaxClassEnum;
    brandIds: Array<string>;
    masterProduct: object;
    variations?: Array<Variation>;
    productAngles?: Array<ProductAngle>;
    country: object;
    product: object;
    trackingUUID: string;
}
export namespace ProductTranslation {
    export const StateEnum = {
        draft: 'draft',
        published: 'published',
        publishing: 'publishing',
        optimizing_media: 'optimizing_media',
        translating: 'translating',
        waiting_proofread: 'waiting_proofread',
        approved: 'approved'
    } as const;
    export type StateEnum = typeof StateEnum[keyof typeof StateEnum];
    export const ProductTypeEnum = {
        simple: 'simple',
        variable: 'variable',
        upsell: 'upsell',
        bundle: 'bundle'
    } as const;
    export type ProductTypeEnum = typeof ProductTypeEnum[keyof typeof ProductTypeEnum];
    export const TypeEnum = {
        simple: 'simple',
        grouped: 'grouped',
        external: 'external',
        variable: 'variable'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
    export const StatusEnum = {
        draft: 'draft',
        pending: 'pending',
        private: 'private',
        publish: 'publish'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
    export const CatalogVisibilityEnum = {
        visible: 'visible',
        catalog: 'catalog',
        search: 'search',
        hidden: 'hidden'
    } as const;
    export type CatalogVisibilityEnum = typeof CatalogVisibilityEnum[keyof typeof CatalogVisibilityEnum];
    export const TaxClassEnum = {
        standard: 'standard',
        nicelna_stopnja: 'nicelna-stopnja',
        reduced_rate: 'reduced-rate',
        zero_rate: 'zero-rate',
        znizana_stopnja: 'znizana-stopnja',
        znizana_stopnja_49030000: 'znizana-stopnja-49030000'
    } as const;
    export type TaxClassEnum = typeof TaxClassEnum[keyof typeof TaxClassEnum];
}


